<template>
  <div></div>
</template>

<!-- <script>
export default {
  name: "FooterArea",

  data() {
    return {
      cuYear: "",
    };
  },
  mounted() {
    this.cuYear = new Date().getFullYear();
  },
};
</script> -->

<script setup>
import { ref, onMounted } from 'vue';

const cuYear = ref('');


const scriptUrls = [
 "/js/jquery.js",
  "/js/owl.carousel.min.js",
  "/js/bootstrap.min.js",
  "/js/aos.js",
 
 "/js/mainn.js",
 
  
  
]

const scriptLoaded = ref(false)



onMounted(() => {
  cuYear.value = new Date().getFullYear();


  loadScripts(scriptUrls).
    then(()=>{
        scriptLoaded.value=true       
    }).
    catch((error)=>{
        console.error('Error loading scripts:', error)
    })
});


// Script loader
async function loadScript(url) {
 
   return new Promise((resolve, reject)=>{
        const script = document.createElement('script')
        script.src= url
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
    })
}

async function loadScripts(urls) {
  for (const url of urls) {
    await loadScript(url)
  }
}


</script>


